import { useContext } from 'react';
import { globalAction } from '../store';

export const useNotify = () => {
  const { setState } = useContext(globalAction);

  return (message, { type, timeout }) => {
    setState(state => ({ ...state, notify: { type, message, isOpen: true } }));
    const timeoutId = setTimeout(() => {
      setState(state => ({ ...state, notify: { type, message, isOpen: false } }));
      clearTimeout(timeoutId);
    }, timeout || 3000);
  };
};
